import { TApi } from './types';
import { dashboard } from './dashboard';
import { monthlyFee } from './monthlyFee';
import { user } from './user';
import { vatreport } from './vatreport';
import { errorCorrections } from './errorCorrections';
import { swissPost } from './swissPost';
import { swedBank } from './swedBank';
import { mtd } from './mtd';
import { gpsr } from './gpsr';
import { vatReimbursement } from './vatReimbursement';
import { salesProcessing } from './salesProcessing';
import { referrals } from './referrals';
import { emManagement } from './emManagement';
import { country } from './country';
import { currency } from './currency';
import { exchangeRates } from './exchangeRates';
import { taxDuties } from './taxDuties';
import { fiscalReports } from './fiscalReports';
import { accessManagement } from './accessManagement';
import { changeHistory } from './changeHistory';
import { emProductFileUploads } from './emProductFileUploads/index';
import { emVat } from './emVat';
import { emVatReports } from './emVatReports';
import { emAttachments } from './emAttachments1';
import { attachments } from './attachments';
import { eudr } from './eudr';
import { jotform } from './jotform';
import { userRoles } from './userRoles';
import { generalAttachments } from './generalAttachments';
import { emAutomationScripts } from './emAutomationScripts';
import { invoiceManagement } from './invoiceManagement';
import { orderManagement } from './orderManagement';
import { emails } from './emails';
import { sms } from './sms';
import { emVatCorrectionsImport } from './emVatCorrectionsImport';
import { euDdp } from './euDdp';
import { shopifyStores } from './shopifyStores';
import { emSalesReports } from './emSalesReports';
import { easInfo } from './easInfo';
import { reports } from './reports';
import { easFee } from './easFee';
import { massPostSaleJobs } from './massPostSaleJobs';
import { superset } from './superset';
import { prp } from './prp';
import { supportedPostalOperators } from './supportedPostalOperators';
import { ppwr } from './ppwr';
import { paymentGateway } from './paymentGateway';

const api: TApi = {
	user,
	dashboard,
	monthlyFee,
	vatreport,
	errorCorrections,
	swissPost,
	swedBank,
	mtd,
	gpsr,
	vatReimbursement,
	salesProcessing,
	referrals,
	emManagement,
	country,
	currency,
	exchangeRates,
	taxDuties,
	fiscalReports,
	accessManagement,
	changeHistory,
	emProductFileUploads,
	emVat,
	emVatReports,
	emAttachments,
	attachments,
	eudr,
	jotform,
	userRoles,
	generalAttachments,
	emAutomationScripts,
	invoiceManagement,
	orderManagement,
	emails,
	sms,
	emVatCorrectionsImport,
	euDdp,
	shopifyStores,
	emSalesReports,
	easInfo,
	reports,
	easFee,
	massPostSaleJobs,
	superset,
	prp,
	supportedPostalOperators,
	ppwr,
	paymentGateway,
};

export { api };
